import styled, { css } from 'styled-components';

const IconFont = styled.i`
  font-size: ${props => props.font}px;
  ${props => props.marginRight && css`
    margin-right: ${props.marginRight !== 'auto' ? `${props.marginRight}em` : props.marginRight};
  `}
  ${props => props.marginLeft && css`
    margin-left: ${props.marginLeft !== 'auto' ? `${props.marginLeft}em` : `${props.marginLeft}`};
  `}
  ${props => props.marginTop && css`
    margin-top: ${props.marginTop !== 'auto' ? `${props.marginTop}em` : `${props.marginTop}`};
  `}

  color: ${props => (props.isAvailable ? 'black' : 'grey')};
  background: ${props => (props.theme.colors[props.bgColor])};
  
  border-radius: ${props => props.borderRadius}px;
  
  ${props => (props.color && props.color.indexOf('#') !== -1) && css`
    color: ${props.color};
  `};
  ${props => (props.color && props.color.indexOf('#') === -1) && css`
     color: ${props.theme.colors[props.color]};
  `};
  
  ${props => props.isSelected && css`
    color: ${props.theme.colors.selectedColor};
  `}
  
  ${props => props.isSelectedFavourites && css`
    color: white !important;
  `}
  font-weight: ${props => (props.weight ? `${props.weight} !important` : 'normal')};
  cursor: ${props => (props.withCursor ? 'pointer' : 'default')};
  padding: 0;
  line-height: ${props => (props.lineHeight ? `${props.lineHeight} !important` : 1)};

  ${props => props.opacity && css`
    opacity: ${props.opacity};
  `}

  ${props => props.noPadding && css`
    padding: 0;
  `}

  ${props => props.noBottom && css`
    border-bottom: 0 none;
  `}
  
  &:hover:before {
    ${props => props.isAvailable && props.isFilterBar && css`
       color: ${props.theme.colors.selectedColor};
    `}
  }

  &:before {
    color: ${props => (props.isAvailable ? 'black' : 'rgb(186,186,186)')};
    ${props => props.isSelected && css`
      color: ${props.theme.colors.selectedColor};
    `}
    ${props => props.isSelectedFavourites && css`
      color: white !important;
    `}
    ${props => (props.color && props.color.indexOf('#') !== -1) && css`
      color: ${props.color};
    `};
    ${props => (props.color && props.color.indexOf('#') === -1) && css`
      color: ${props.theme.colors[props.color]};
    `};
  }
`;

export default IconFont;
